import React from "react";
import Tasks from "../../components/tasks";
import PomoTimer from "../../components/pomo-timer";
import ActivitySummary from "../../components/activity-summary";
import {Root, Right} from "./styles";
const SoloStudy = () => {
  return (
    <Root id="solo-study">
      <Tasks />
      <Right>
        <PomoTimer />
        <ActivitySummary />
      </Right>
    </Root>
  );
};

export default SoloStudy;
